import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import { NAMESPACE_ITEMS } from 'actions/inventory/constants';

export function inventoryTransferStart({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory Transfer Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}

export function inventoryTransferCreate({
  outletFromName,
  outletToName,
  namespace,
  items,
}) {
  const data = {
    'Outlet From Name': outletFromName,
    'Outlet to Name': outletToName,
    'Current Inventory Filter': namespace,
  };
  if (namespace === NAMESPACE_ITEMS) {
    data['List of Items'] = items.map(d => ({
      'Item Name': d.name,
      'Variant Name': d.item_variant_name,
      'Qty Beginning Stock': d.beginning_stock,
      'Qty Transfer': parseInt(d.quantity),
    }));
  } else {
    data['List of Ingredients'] = items.map(d => ({
      'Ingredient Name': d.ingredient_name,
      'Qty Beginning Stock': d.beginning_stock,
      'Qty Transfer': parseInt(d.quantity),
      Unit: d.unit_name,
    }));
  }
  pushClevertapEvent('Inventory Transfer Create', data);
}

export function inventoryTransferExport({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory Transfer Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}
